import { useGet } from '../../../../api';
import { USER_MANAGEMENT_BASE_URL } from '../consts';

interface Params {
    entityGuid: string;
    enabled?: boolean;
}

interface Response {
    count: number;
}

export const useGetEntityUsersChildrenCount = ({ entityGuid, enabled = true }: Params) => {
    const { data, ...restValues } = useGet<Response>({
        url: `${USER_MANAGEMENT_BASE_URL}/entity/${entityGuid}/usersChildrenCount`,
        enabled
    });

    return {
        count: data?.count,
        ...restValues
    };
};
